<template>
	<div class="z-day-bar">
		<ol class="fx b-r-3">
			<li :class='[active == 7 ? "active" : ""]' @click="handleClick(7)">最近7天</li>
			<li :class='[active == 15 ? "active" : ""]' @click="handleClick(15)">最近15天</li>
			<li :class='[active == 30 ? "active" : ""]' @click="handleClick(30)">最近30天</li>
		</ol>
	</div>
</template>
<script>
	export default {
		name:"z-daybar",
		data() {
			return {
				active:7	
			}
			
		},
		/*
		 * 接收父组件数据
		 */
		props: {
			onClick: Function
		},
		methods: {
			handleClick(day){
				this.active = day
				this.onClick(day)
			}
		}
	}
</script>
<!-- 添加 scoped “范围”属性CSS限制这个组件只 -->
<style scoped lang="scss">
	@import "src/assets/css/common.scss";
	.z-day-bar {
		ol li {
			+li {
				border-left: none;
			}
			transition: all 0.2s ease;
			padding: px-em(10px) px-em(20px);
			cursor: pointer;
			border: 1px solid $color-border;
			&:hover {
				background: rgba(0, 0, 0, 0.1);
			}
			&.active {
				background: rgba(0, 0, 0, 0.1);
			}
		}
	}
</style>


// WEBPACK FOOTER //
// DayBar.vue?6076019c